export interface SentryConfig {
  enabled: boolean
  dsn?: string
  environment: string
  /** Release identifier for Sentry (app version from GitVersion / VITE_APP_VERSION) */
  release: string
  isProduction: boolean
  tracesSampleRate: number
  replaysSessionSampleRate: number
  replaysOnErrorSampleRate: number
}

// Use MODE as the single source of truth for environment
const mode = import.meta.env.MODE || 'development'
const isProduction = mode === 'production'

const appVersion = import.meta.env.VITE_APP_VERSION ?? '0.0.0-local'

export const sentryConfig: SentryConfig = {
  enabled: true,
  dsn: import.meta.env.VITE_SENTRY_DSN || "https://8bf177d2bf0b44b0a9eca54280342365@o990819.ingest.us.sentry.io/5947604",
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || mode,
  release: `crossroad-web@${appVersion}`,
  isProduction,
  tracesSampleRate: isProduction ? 0.1 : 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
}

